import React from 'react';
import classNames from 'classnames';
import { getBackgroundImgStyle } from '../../utils/helpers/themeHelper.mjs';
import { QuestionGroupViewPropTypes } from '../../utils';

/**
 * ImageLayout is a question group layout component that displays questions on the left side
 * and an image on the right side. The image is configured through
 * the questionGroup's attributes.imgKey property.
 * 
 * This layout is particularly useful for:
 * - Welcome pages with a branded image
 * - Question pages that need visual context
 * - Pages requiring a split view of content and imagery
 * 
 * The component follows BEM naming conventions for CSS classes and uses
 * a light gray background ($neuro-imageLayout-fallback-bg) as a fallback when no image is provided.
 * 
 * @example
 * {
 *   "key": "businessStage",
 *   "questionGroups": [
 *     {
 *       "key": "businessStageQuestionGroup",
 *       "type": "ImageLayout",
 *       "attributes": {
 *         "imgKey": "welcome-image.svg"
 *       },
 *       "questions": [
 *         {
 *           "type": "Slider",
 *           "appkey": "business_yearsInBusiness"
 *         }
 *       ]
 *     }
 *   ]
 * }
 * 
 * @param {Object} props
 * @param {Object} props.questionGroup - The question group containing attributes and questions
 * @param {Function} props.renderQuestion - Function to render individual questions
 * @param {Object} props.page - The current page object
 * @param {Object} [props.customProps] - Additional custom properties
 */
const ImageLayout = ({ questionGroup, renderQuestion }) => {
  const componentClass = 'imageLayout';
  const classes = classNames(componentClass, `questionGroup--${componentClass}`);
  const imageStyle = getBackgroundImgStyle(`/classpath/assets/images/svg/${questionGroup.attributes.imgKey}`);


  return (
    <section className={classes}>
      <div className='questionContainer'>
        {questionGroup.questions.map(question => (
          <div key={question.appkey}>
            {renderQuestion(question)}
          </div>
        ))}
      </div>
      <div className={`${componentClass}__image`} style={imageStyle} />
    </section>
  );
};

ImageLayout.propTypes = QuestionGroupViewPropTypes;

export default ImageLayout; 